import * as R from 'ramda';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// translations
import en from './resources/en';
//////////////////////////////////////////////////

const resources = { en };

i18n.use(initReactI18next).init({
  resources: {
    ...Object.entries(resources).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: {
          translation: value,
        },
      }),
      {},
    ),
  },
  fallbackLng: 'en',
  defaultLanguage: 'en',
  compatibilityJSON: 'v3',
  lng: R.or(localStorage.getItem('locale'), 'en'),
});

export default i18n;
